(() => {
  const cardSelector = '[data-wp-card]';
  const swatchSelector = '[data-wp-card-swatch]';
  const finePointerQuery = window.matchMedia('(hover: hover) and (pointer: fine)');
  const states = new WeakMap();

  function stateFor(card) {
    let state = states.get(card);
    if (state) return state;

    const image = card.querySelector('[data-wp-card-primary-image]');
    if (!image) return null;

    state = {
      image,
      defaultImage: {
        src: image.getAttribute('src') || '',
        srcset: image.getAttribute('srcset') || '',
        alt: image.getAttribute('alt') || '',
      },
      selected: null,
      imageRequest: 0,
      preloads: new Map(),
    };
    states.set(card, state);
    return state;
  }

  function preloadSource(state, source) {
    if (!source) return null;
    let preload = state.preloads.get(source);
    if (!preload) {
      preload = new Image();
      preload.decoding = 'async';
      preload.src = source;
      state.preloads.set(source, preload);
    }
    return preload;
  }

  function preloadCardSources(card) {
    const state = stateFor(card);
    if (!state) return;
    card.querySelectorAll(swatchSelector).forEach((swatch) => {
      preloadSource(state, swatch.dataset.imageSrc);
    });
  }

  function updateImage(state, source, alt) {
    if (!source) return;

    state.imageRequest += 1;
    preloadSource(state, source);
    // Click feedback must be immediate. Waiting for a remote image to finish
    // loading made a selected SKU look unresponsive on desktop.
    state.image.removeAttribute('srcset');
    state.image.setAttribute('src', source);
    state.image.setAttribute('alt', alt || '');
  }

  function applySwatch(card, swatch, persist) {
    const state = stateFor(card);
    if (!state) return;

    updateImage(state, swatch.dataset.imageSrc, swatch.dataset.imageAlt);

    if (!persist) return;
    state.selected = swatch;
    card.classList.add('wp-card--sku-selected');
    card.querySelectorAll(swatchSelector).forEach((button) => {
      button.setAttribute('aria-pressed', button === swatch ? 'true' : 'false');
    });
  }

  function restoreSelection(card) {
    const state = stateFor(card);
    if (!state) return;

    card.classList.remove('wp-card--color-preview');
    if (state.selected) {
      applySwatch(card, state.selected, false);
      return;
    }

    state.imageRequest += 1;
    state.image.setAttribute('src', state.defaultImage.src);
    if (state.defaultImage.srcset) state.image.setAttribute('srcset', state.defaultImage.srcset);
    else state.image.removeAttribute('srcset');
    state.image.setAttribute('alt', state.defaultImage.alt);
  }

  function swatchFromEventTarget(target) {
    if (!(target instanceof Element)) return null;
    return target.closest(swatchSelector);
  }

  function selectSwatch(event) {
    const swatch = swatchFromEventTarget(event.target);
    if (!swatch) return;
    const card = swatch.closest(cardSelector);
    if (!card) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    applySwatch(card, swatch, true);
    card.classList.remove('wp-card--color-preview');
  }

  document.addEventListener('pointerenter', (event) => {
    if (!finePointerQuery.matches) return;
    const enteredCard = event.target instanceof Element ? event.target.closest(cardSelector) : null;
    if (enteredCard) preloadCardSources(enteredCard);
    const swatch = swatchFromEventTarget(event.target);
    if (!swatch) return;
    const card = swatch.closest(cardSelector);
    if (!card) return;
    const state = stateFor(card);
    if (state) preloadSource(state, swatch.dataset.imageSrc);
    card.classList.add('wp-card--color-preview');
    applySwatch(card, swatch, false);
  }, true);

  document.addEventListener('pointerleave', (event) => {
    if (!finePointerQuery.matches) return;
    const swatch = swatchFromEventTarget(event.target);
    if (!swatch) return;
    const card = swatch.closest(cardSelector);
    if (card) restoreSelection(card);
  }, true);

  document.addEventListener('focusin', (event) => {
    const swatch = swatchFromEventTarget(event.target);
    if (!swatch) return;
    const card = swatch.closest(cardSelector);
    if (!card) return;
    card.classList.add('wp-card--color-preview');
    applySwatch(card, swatch, false);
  });

  document.addEventListener('focusout', (event) => {
    const swatch = swatchFromEventTarget(event.target);
    if (!swatch) return;
    const card = swatch.closest(cardSelector);
    if (card) restoreSelection(card);
  });

  // Apply on press for every pointer type. This runs before a card link or
  // browser-generated click can interfere with the intended SKU selection.
  document.addEventListener('pointerdown', (event) => {
    selectSwatch(event);
  }, true);

  // Touch devices also apply on release, before any delayed synthetic click.
  document.addEventListener('pointerup', (event) => {
    if (event.pointerType !== 'touch') return;
    selectSwatch(event);
  }, true);

  document.addEventListener('click', (event) => {
    selectSwatch(event);
  }, true);
})();
